"use strict";
var PopOver = (function () {
    function PopOver(el, trigger) {
        this.element = el;
        this.trigger = trigger;
    }
    return PopOver;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PopOver;
